export const queryKeys = {
  base: ['person-pets'] as const,
  personPets: (personId?: string) => [...queryKeys.base, personId],
  petExtended: (petId?: string) => [...queryKeys.base, 'pet-extended', petId],
};
